// @flow
import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
  Box,
  Input,
  Stack,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';
import messages from '../../messages';
import { RenderTermCost } from '../OfferRentRow';

type RenderTransactionCodesProps = {
  transactionCode: Object,
};

const RenderTransactionCodes = ({
  transactionCode,
}: RenderTransactionCodesProps) => (
  <Box sx={{ width: '25%' }} data-test="render-term-length">
    <Box component="label" sx={{ display: 'block', typography: 'labelLarge' }}>
      <FormattedMessage {...messages.transactionCode} />
    </Box>
    <Input value={`${transactionCode.code}`} disabled fullWidth />
  </Box>
);

type RenderTransactionCodeRowProps = {
  lot: Object,
};

const RenderTransactionCodeRow = ({ lot }: RenderTransactionCodeRowProps) => (
  <Stack direction="row" alignItems="flex-end" spacing={2}>
    <RenderTransactionCodes transactionCode={lot.transactionCode} />
    <RenderTermCost cost={lot.offer1amount} />
    <RenderTermCost cost={lot.offer2amount} />
    <RenderTermCost cost={lot.offer3amount} />
    <Box sx={{ width: 40, flexShrink: 0 }} />
  </Stack>
);

type Props = {
  lotx: ?Array<Object>,
};

const TransactionCodeRows = ({ lotx }: Props) =>
  lotx
    ? lotx.map((lot, index) => (
        <RenderTransactionCodeRow key={index} lot={lot} />
      ))
    : null;

export default TransactionCodeRows;
